<div style="overflow: auto;position: relative">
  <ngx-ui-loader
    [loaderId]="'loaderLogin'"
    [bgsPosition]="'bottom-right'"
    [bgsType]="'ball-spin-clockwise'"
    [fgsPosition]="'center-center'"
    [fgsType]="'ball-spin-clockwise'"
    [logoPosition]="'center-center'"
    [pbDirection]="'ltr'"
    [textColor]="'#FFFFFF'"
    [textPosition]="'center-center'"
  ></ngx-ui-loader>
  <router-outlet></router-outlet>
</div>
